export default __webpack_public_path__ + "static/media/Dress - Mens.5c4fca50.jpg";